import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";

export default {
    methods: {
        $_gtmTrackEvent(props = {}) {
            if (_isEmpty(props)) {
                return;
            }
            const moduleGroups = {
                hibooks: "audiobooks",
                nonfiction: "insights"
            };
            const module = moduleGroups[this.$route.meta.group];
            const userData = this.$store.state.User.data;
            const userId = _isEmpty(userData) ? undefined : userData.user.user_id;
            const userEmail =
                _get(userData, "user.email_address", "") ||
                _get(userData, "facebook.email_address", "") ||
                _get(userData, "email", "") ||
                this.$route.query.email ||
                undefined;
            const customEventProps = { module, userId, userEmail, ...props }; // { module, userId, event, action, ...params }

            this.$gtm.trackEvent(customEventProps);
        }
    }
}
